import { useEffect, useState } from "react";
import { NormalizedStorageObject } from "../../../../services/api/instances/storageApi/types/object_types";
import { getAllStorageObjects } from "../../../../services/api/instances/storageApi/methods";
import { normalizeStorageObjects } from "../../../../app/state/storageObjectSlice/utils/normalizeStorageObjects/normalizeStorageObjects";
import { AssistantValue } from "../../../../services/api/instances/assistantsApi/types";

export const useInitAssistantOptions = () => {
  const [assistants, setAssistants] = useState<
    NormalizedStorageObject<AssistantValue>[]
  >([]);

  useEffect(() => {
    getAllStorageObjects("assistants").then((assistants) => {
      if (assistants) {
        const normalizedAssistants = Object.values(
          normalizeStorageObjects(assistants).entities,
        ) as NormalizedStorageObject<AssistantValue>[];
        setAssistants(normalizedAssistants);
      }
    });
  }, []);

  return {
    assistants,
  };
};
